"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfMaterialSpecDetailSearchModel = instanceOfMaterialSpecDetailSearchModel;
exports.MaterialSpecDetailSearchModelFromJSON = MaterialSpecDetailSearchModelFromJSON;
exports.MaterialSpecDetailSearchModelFromJSONTyped = MaterialSpecDetailSearchModelFromJSONTyped;
exports.MaterialSpecDetailSearchModelToJSON = MaterialSpecDetailSearchModelToJSON;
exports.MaterialSpecDetailSearchModelToJSONTyped = MaterialSpecDetailSearchModelToJSONTyped;
/**
 * Check if a given object implements the MaterialSpecDetailSearchModel interface.
 */
function instanceOfMaterialSpecDetailSearchModel(value) {
    return true;
}
function MaterialSpecDetailSearchModelFromJSON(json) {
    return MaterialSpecDetailSearchModelFromJSONTyped(json, false);
}
function MaterialSpecDetailSearchModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderString': json['orderString'] == null ? undefined : json['orderString'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'msdMaterialNo': json['msdMaterialNo'] == null ? undefined : json['msdMaterialNo'],
    };
}
function MaterialSpecDetailSearchModelToJSON(json) {
    return MaterialSpecDetailSearchModelToJSONTyped(json, false);
}
function MaterialSpecDetailSearchModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderString': value['orderString'],
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'msdMaterialNo': value['msdMaterialNo'],
    };
}
